import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appWidgetInner]'
})
export class WidgetInnerDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
